import { formatDistance } from "./de/_lib/formatDistance.js";
import { formatLong } from "./de/_lib/formatLong.js";
import { formatRelative } from "./de/_lib/formatRelative.js";
import { localize } from "./de/_lib/localize.js";
import { match } from "./de/_lib/match.js";

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const de = {
  code: "de",
  formatDistance: formatDistance,
  formatLong: formatLong,
  formatRelative: formatRelative,
  localize: localize,
  match: match,
  options: {
    weekStartsOn: 1 /*        */,
    firstWeekContainsDate: 4,
  },
};

/*                                */
export default de;
